export default __webpack_public_path__ + "static/media/submission_screen.9301cb45.png";